import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService, BreadcrumbItem } from './breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnChanges {

  @Input() useCaseKey!: string;
  @Input() flowKey!: string;

  public breadcrumbItems: BreadcrumbItem[] = [];

  constructor(private router: Router, private breadcrumbService: BreadcrumbService) {}

  onBreadcrumbClick(item: BreadcrumbItem): void {
    if (item.link) {
      this.router.navigateByUrl(item.link);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['useCaseKey'] || changes['flowKey']) {
      this.loadBreadcrumbs();
    }
  }

  private loadBreadcrumbs(): void {
    if (this.useCaseKey && this.flowKey) {
      this.breadcrumbItems = this.breadcrumbService.getBreadcrumbs(this.useCaseKey, this.flowKey);
    } else {
      this.breadcrumbItems = [];
    }
  }
}